module.exports = __webpack_public_path__ + "assets/img/refresh.835feb5f.svg";